var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mentor (Messages)",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-1153 -325)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 19"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-33 -252H287V65H-33V-252Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-33 65H-34V66H-33V65ZM287 64H-33V66H287V64ZM-32 65V-252H-34V65H-32Z",
    fill: "#E0E0E0",
    mask: "url(#path-1-inside-1_0_1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 163169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 163164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 162844"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 12,
    cy: 12,
    r: 20,
    fill: "white",
    stroke: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vscode-icons:file-type-word"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.6053 2.25H7.27952C7.16211 2.2499 7.04584 2.27293 6.93734 2.31777C6.82884 2.3626 6.73023 2.42837 6.64714 2.51132C6.56406 2.59426 6.49812 2.69276 6.4531 2.80119C6.40809 2.90962 6.38486 3.02585 6.38477 3.14325V7.125L14.6865 9.5625L22.5008 7.125V3.14325C22.5007 3.02579 22.4774 2.90949 22.4324 2.80102C22.3873 2.69254 22.3213 2.59401 22.2381 2.51105C22.155 2.4281 22.0563 2.36234 21.9477 2.31755C21.8391 2.27276 21.7227 2.2498 21.6053 2.25Z",
    fill: "#41A5EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.5008 7.125H6.38477V12L14.6865 13.4625L22.5008 12V7.125Z",
    fill: "#2B7CD3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.38477 12V16.875L14.1983 17.85L22.5008 16.875V12H6.38477Z",
    fill: "#185ABD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.27952 21.75H21.6045C21.722 21.7503 21.8385 21.7274 21.9472 21.6827C22.0558 21.6379 22.1546 21.5722 22.2379 21.4892C22.3211 21.4062 22.3872 21.3077 22.4323 21.1992C22.4774 21.0906 22.5007 20.9743 22.5008 20.8568V16.875H6.38477V20.8568C6.38486 20.9742 6.40809 21.0904 6.4531 21.1988C6.49812 21.3072 6.56406 21.4057 6.64714 21.4887C6.73023 21.5716 6.82884 21.6374 6.93734 21.6822C7.04584 21.7271 7.16211 21.7501 7.27952 21.75Z",
    fill: "#103F91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.1,
    d: "M12.3263 6.1499H6.38477V18.3374H12.3263C12.563 18.3362 12.7898 18.2418 12.9574 18.0746C13.125 17.9074 13.22 17.6809 13.2218 17.4442V7.04315C13.22 6.80641 13.125 6.57989 12.9574 6.4127C12.7898 6.2455 12.563 6.15108 12.3263 6.1499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.2,
    d: "M11.838 6.6377H6.38477V18.8252H11.838C12.0748 18.824 12.3015 18.7296 12.4691 18.5624C12.6368 18.3952 12.7317 18.1687 12.7335 17.9319V7.53095C12.7317 7.2942 12.6368 7.06769 12.4691 6.90049C12.3015 6.73329 12.0748 6.63887 11.838 6.6377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.2,
    d: "M11.838 6.6377H6.38477V17.8502H11.838C12.0748 17.849 12.3015 17.7546 12.4691 17.5874C12.6368 17.4202 12.7317 17.1937 12.7335 16.9569V7.53095C12.7317 7.2942 12.6368 7.06769 12.4691 6.90049C12.3015 6.73329 12.0748 6.63887 11.838 6.6377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.2,
    d: "M11.3498 6.6377H6.38477V17.8502H11.3498C11.5865 17.849 11.8133 17.7546 11.9809 17.5874C12.1485 17.4202 12.2435 17.1937 12.2453 16.9569V7.53095C12.2435 7.2942 12.1485 7.06769 11.9809 6.90049C11.8133 6.73329 11.5865 6.63887 11.3498 6.6377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M2.3955 6.6377H11.349C11.5862 6.6375 11.8137 6.73147 11.9816 6.89897C12.1496 7.06646 12.2441 7.29377 12.2445 7.53095V16.4694C12.2441 16.7066 12.1496 16.9339 11.9816 17.1014C11.8137 17.2689 11.5862 17.3629 11.349 17.3627H2.3955C2.27804 17.3629 2.16168 17.3399 2.05309 17.2951C1.9445 17.2504 1.84581 17.1846 1.76264 17.1016C1.67948 17.0187 1.61348 16.9202 1.56841 16.8117C1.52334 16.7032 1.5001 16.5869 1.5 16.4694V7.53095C1.5001 7.41348 1.52334 7.29719 1.56841 7.18871C1.61348 7.08023 1.67948 6.9817 1.76264 6.89875C1.84581 6.81579 1.9445 6.75004 2.05309 6.70525C2.16168 6.66045 2.27804 6.6375 2.3955 6.6377Z",
    fill: "url(#paint0_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M5.17508 13.4908C5.19233 13.6288 5.20433 13.7488 5.20958 13.8516H5.23058C5.23808 13.7541 5.25458 13.6363 5.27933 13.4991C5.30408 13.3618 5.32583 13.2456 5.34608 13.1503L6.28733 9.09509H7.50533L8.48033 13.0896C8.53712 13.3367 8.5777 13.5872 8.60183 13.8396H8.61833C8.63624 13.5939 8.67006 13.3497 8.71958 13.1083L9.49883 9.08984H10.6066L9.23858 14.9008H7.94333L7.01558 11.0563C6.98858 10.9453 6.95808 10.8008 6.92408 10.6228C6.89008 10.4448 6.86908 10.3148 6.86108 10.2328H6.84533C6.83483 10.3273 6.81383 10.4676 6.78233 10.6536C6.75083 10.8403 6.72608 10.9776 6.70733 11.0676L5.83508 14.9031H4.51808L3.14258 9.09509H4.26758L5.11583 13.1586C5.14114 13.2683 5.16092 13.3792 5.17508 13.4908Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 3.3705,
    y1: 5.9357,
    x2: 10.374,
    y2: 18.0647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2368C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A5DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1146AC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-1153 -325)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.f4bbcff9ab087b65f64a23dd27570d4b.svg";
export { ForwardRef as ReactComponent };